import ListLoading from './ListLoading'

/**
 * 初始化无限加载组件
 * @param Vue
 */
ListLoading.install = function (Vue) {
  Vue.component(ListLoading.name, ListLoading)
}

/**
 * 无限加载组件
 */
export default ListLoading



// WEBPACK FOOTER //
// ./src/components/common/comp/ListLoading/index.js